import {
  ConfigurationFormType,
  ConfigurationPageTable,
  ConfigurationPageType,
  ConfigurationTableFilterType,
} from "../interfaces";
import { FormatType } from "../../Alert/Filter/FilterType";
import { replaceNonNumeric } from "../../services/utils";

export const businessRuleAttributes = {
  KPI_PROPERTY_VALUES: "kpi_property_values",
  KPI_UHTYPENANDC_VALUES: "kpi_uhtypenandc_values",
  KPI_UHCAT_VALUES: "kpi_uhcat_values",
};

export const businessRuleI18n = {
  [businessRuleAttributes.KPI_PROPERTY_VALUES]: "PROPERTY",
  [businessRuleAttributes.KPI_UHTYPENANDC_VALUES]: "UH_TYPES_NANDC",
  [businessRuleAttributes.KPI_UHCAT_VALUES]: "UH_CAT",
};

export const SETUP_BUSINESS_RULES_PAGE: ConfigurationPageTable = {
  type: ConfigurationPageType.TABLE,
  label: "BUSINESS_RULES_MENU",
  menuLabel: "BUSINESS_RULES_MENU",
  pageLabel: "BUSINESS_RULES_TITLE_SETUP",
  path: "business-rules",
  hideInMenu: true,
  flagRequired: "is_active_businessrules",
  description: "CONF_DESC_SETUP_BUSINESS_RULES",
  model: {
    entityName: "business_rules",
    label: "BUSINESS_RULES_MENU",
    path: "/api/business-rules",
    bulkPath: "/api/business-rules/bulk-updates",
    name: "Business rule",
    attributes: [
      {
        key: "rank",
        order: 1,
        label: "RANK",
        type: FormatType.NUMBER,
        visible: true,
      },
      {
        key: "name",
        order: 2,
        label: "BUSINESS_RULE_NAME",
        type: FormatType.TEXT,
        visible: true,
      },
      {
        align: "right",
        key: "application_start_date",
        order: 3,
        label: "APPLICATION_START_DATE",
        type: FormatType.DATE,
        format: {
          day: "numeric",
          month: "numeric",
          year: "numeric",
        },
        visible: true,
      },
      {
        align: "right",
        key: "application_end_date",
        order: 4,
        label: "APPLICATION_END_DATE",
        type: FormatType.DATE,
        format: {
          day: "numeric",
          month: "numeric",
          year: "numeric",
        },
        visible: true,
      },
      {
        align: "right",
        key: "occupation_start_date",
        order: 5,
        label: "OCCUPATION_START_DATE",
        type: FormatType.DATE,
        format: {
          day: "numeric",
          month: "numeric",
          year: "numeric",
        },
        visible: true,
      },
      {
        align: "right",
        key: "occupation_end_date",
        order: 6,
        label: "OCCUPATION_END_DATE",
        type: FormatType.DATE,
        format: {
          day: "numeric",
          month: "numeric",
          year: "numeric",
        },
        visible: true,
      },
      {
        key: "dimension_attr_values",
        order: 7,
        label: "BUSINESS_RULE_PERIMETER",
        type: FormatType.BUSINESS_RULE_PERIMETER,
        visible: true,
      },
      {
        key: `${businessRuleAttributes.KPI_PROPERTY_VALUES},${businessRuleAttributes.KPI_UHTYPENANDC_VALUES},${businessRuleAttributes.KPI_UHCAT_VALUES}`,
        order: 8,
        label: "BUSINESS_RULE_CONDITIONS",
        type: FormatType.BUSINESS_RULE_CONDITIONS,
        visible: true,
      },
      {
        key: "actions",
        order: 9,
        label: "BUSINESS_RULE_ACTION",
        type: FormatType.BUSINESS_RULE_ACTION,
        visible: true,
      },
      {
        key: "is_enabled",
        order: 10,
        label: "IS_ENABLED",
        type: FormatType.BOOLEAN,
        visible: true,
      },
    ],
    filters: [
      {
        type: ConfigurationTableFilterType.SelectMultiple,
        mustTranslateOptions: false,
        api: "/api/business-rules/actions/",
        apiParams: {
          page_size: 100,
          ordering: "id",
        },
        key: "id",
        labelKey: "label",
        label: "BUSINESS_RULES_ACTION",
        lookup: "action_type",
        controlledInputSize: true,
      },
      {
        type: ConfigurationTableFilterType.Search,
      },
      {
        type: ConfigurationTableFilterType.ResetButton,
      },
    ],
    // disable export for now, not yet functionnal
    // exportPath: "/api/business-rules/actions/export",
  },
  options: {
    formFields: [
      {
        key: "name",
        label: "BUSINESS_RULE_NAME",
        type: ConfigurationFormType.Input,
      },
      {
        key: "rank",
        label: "RANK",
        inputReplacer: (value = "") => replaceNonNumeric(value),
        type: ConfigurationFormType.Input,
        defaultValue: "0",
      },
      {
        api: "/api/dimensions/?=active_alerts",
        apiParams: {
          page_size: 100,
          ordering: "order",
        },
        key: "dimension_attr_values",
        label: "BUSINESS_RULE_PERIMETER",
        labelKey: "dimension_attr_values",
        type: ConfigurationFormType.BusinessRulePerimeter,
      },
      {
        apiParams: {
          page_size: 100,
          ordering: "order",
        },
        key: businessRuleAttributes.KPI_PROPERTY_VALUES,
        label: "BUSINESS_RULE_CONDITION_KPI_PROPERTY_VALUES",
        labelKey: businessRuleAttributes.KPI_PROPERTY_VALUES,
        type: ConfigurationFormType.BusinessRuleCondition,
      },
      {
        apiParams: {
          page_size: 100,
          ordering: "order",
        },
        key: businessRuleAttributes.KPI_UHTYPENANDC_VALUES,
        label: "BUSINESS_RULE_CONDITION_KPI_UHTYPENANDC_VALUES",
        labelKey: businessRuleAttributes.KPI_UHTYPENANDC_VALUES,
        type: ConfigurationFormType.BusinessRuleCondition,
      },
      {
        apiParams: {
          page_size: 100,
          ordering: "order",
        },
        key: businessRuleAttributes.KPI_UHCAT_VALUES,
        label: "BUSINESS_RULE_CONDITION_KPI_UHCAT_VALUES",
        labelKey: businessRuleAttributes.KPI_UHCAT_VALUES,
        type: ConfigurationFormType.BusinessRuleCondition,
      },
      {
        key: "actions",
        label: "BUSINESS_RULE_ACTION_PARAMETERS",
        type: ConfigurationFormType.BusinessRuleAction,
      },
      {
        key: "application_start_date",
        startDateField: "application_start_date",
        endDateField: "application_end_date",
        startDateLabel: "APPLICATION_START_DATE",
        endDateLabel: "APPLICATION_END_DATE",
        type: ConfigurationFormType.DateRangePicker,
      },
      {
        key: "occupation_start_date",
        startDateField: "occupation_start_date",
        endDateField: "occupation_end_date",
        startDateLabel: "OCCUPATION_START_DATE",
        endDateLabel: "OCCUPATION_END_DATE",
        type: ConfigurationFormType.DateRangePicker,
      },
      {
        key: "is_enabled",
        label: "BUSINESS_RULE_ENABLE",
        type: ConfigurationFormType.Check,
      },
    ],
    creatable: true,
    createOptions: [
      {
        key: "name",
        flex: "100%",
        required: true,
      },
      {
        key: "application_start_date",
        flex: "100%",
        required: true,
      },
      {
        key: "occupation_start_date",
        flex: "100%",
        required: true,
      },
      {
        key: "dimension_attr_values",
        flex: "100%",
        required: true,
      },
      {
        key: businessRuleAttributes.KPI_PROPERTY_VALUES,
        flex: "100%",
        required: true,
      },
      {
        key: businessRuleAttributes.KPI_UHTYPENANDC_VALUES,
        flex: "100%",
        required: true,
      },
      {
        key: businessRuleAttributes.KPI_UHCAT_VALUES,
        flex: "100%",
        required: true,
      },
      {
        key: "actions",
        flex: "100%",
        required: true,
      },
      {
        key: "is_enabled",
        flex: "50%",
        required: true,
      },
    ],
    copyable: false,
    editable: true,
    editOptions: [
      {
        key: "name",
        flex: "100%",
        required: true,
      },
      {
        key: "application_start_date",
        flex: "100%",
        required: true,
      },
      {
        key: "occupation_start_date",
        flex: "100%",
        required: true,
      },
      {
        key: "dimension_attr_values",
        flex: "100%",
        required: true,
      },
      {
        key: businessRuleAttributes.KPI_PROPERTY_VALUES,
        flex: "100%",
        required: true,
      },
      {
        key: businessRuleAttributes.KPI_UHTYPENANDC_VALUES,
        flex: "100%",
        required: true,
      },
      {
        key: businessRuleAttributes.KPI_UHCAT_VALUES,
        flex: "100%",
        required: true,
      },
      {
        key: "actions",
        flex: "100%",
        required: true,
      },
      {
        key: "is_enabled",
        flex: "50%",
        required: true,
      },
    ],
    deletable: true,
    rankable: {
      column: "rank",
      watchLookup: "rank",
    },
  },
};
